export default __webpack_public_path__ + "static/media/FS-HOME-COTIZACION-HOMBRE-IMAGEN.6f8ee6c6.png";